import { render, staticRenderFns } from "./IndexSix.vue?vue&type=template&id=dc4e7f44&"
import script from "./IndexSix.vue?vue&type=script&lang=js&"
export * from "./IndexSix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports